import { type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../utils/styles';

const cardVariants = cva('rounded-3xl transition-all duration-200', {
  variants: {
    variant: {
      default:
        'border-[0.5px] border-white/20 bg-white/45 backdrop-blur-[40px] backdrop-saturate-[180%] shadow-sm',
      accent:
        'border-[0.5px] border-white/20 bg-primary-50/50 backdrop-blur-[40px] backdrop-saturate-[180%] shadow-sm',
      flat: 'border-[0.5px] border-white/20 bg-white/40 shadow-sm',
      interactive:
        'border-[0.5px] border-white/20 bg-white/45 backdrop-blur-[40px] backdrop-saturate-[180%] shadow-sm cursor-pointer hover:bg-white/55 hover:shadow-md',
      glass:
        'bg-white/45 backdrop-blur-[40px] backdrop-saturate-[180%] border-[0.5px] border-white/20 shadow-lg',
      'glass-interactive':
        'bg-white/45 backdrop-blur-[40px] backdrop-saturate-[180%] border-[0.5px] border-white/20 shadow-lg cursor-pointer hover:bg-white/55 hover:shadow-xl',
    },
  },
  defaultVariants: {
    variant: 'glass',
  },
});

export interface CardProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof cardVariants> {
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const paddingMap = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

export function Card({ className, padding = 'md', variant, children, ...props }: CardProps) {
  return (
    <div
      className={cn(cardVariants({ variant }), paddingMap[padding], className)}
      {...props}
    >
      {children}
    </div>
  );
}
